export default __webpack_public_path__ + "static/media/test11.31c7d4f9.png";